import Model from '@/models/Model'

export default class HrEmployee extends Model {
    resource() {
        return 'hr_asset_discount_type'
    }
}